<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Teslim Güncelle</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body" tabindex="0" ngbAutofocus>
    <form [formGroup]="deliveryForm">
        <div class="row col-12">
            <div class="form-group col-xl-6 col-md-6 col-sm-12">
                <label for="company">Firma</label>
                <div class="form-group">
                    <ng-select [items]="companies" bindLabel="companyName" bindValue="id" formControlName="companyId"
                        (change)="onCompanySelect($event)"></ng-select>
                    <div *ngIf="deliveryForm.get('companyId').hasError('required') && deliveryForm.get('companyId').touched"
                        class="text-danger">
                        Firma seçimi zorunludur.
                    </div>
                </div>
            </div>

            <div class="form-group col-xl-6 col-md-6 col-sm-12">
                <label for="company">İlgili Kişi</label>
                <div class="form-group">
                    <ng-select formControlName="companyPersonId">
                        <ng-option *ngFor="let user of companyPersons" [value]="user.id">{{user.name + ' '
                            + user.lastName}}</ng-option>
                    </ng-select>
                </div>
            </div>

            <div class="form-group col-xl-6 col-md-6 col-sm-12">
                <label for="company">Teklif</label>
                <div class="form-group">
                    <ng-select formControlName="transactionManagementId">
                        <ng-option *ngFor="let transaction of transactionManagements"
                            [value]="transaction.id">{{transaction.createdAt |
                            date:'dd.MM.yyyy'}}-{{transaction.no}}-{{getStatusText(transaction.status)}}
                        </ng-option>
                    </ng-select>
                </div>
            </div>

            <div class="form-group col-xl-6 col-md-6 col-sm-12">
                <div class="form-group">
                    <label>Teslim Alma Tarihi</label>
                    <div class="form-group">
                        <ng2-flatpickr [config]="dateTimeStartOptions" [setDate]="date" name="dateTime"
                            formControlName="deliveryDate"></ng2-flatpickr>
                    </div>
                </div>
            </div>

            <div class="form-group col-xl-6 col-md-6 col-sm-12">
                <label for="company">Teslim Alan Personel</label>
                <div class="form-group">
                    <ng-select formControlName="personId">
                        <ng-option *ngFor="let user of persons" [value]="user.id">{{user.name + ' '
                            + user.lastName}}
                        </ng-option>
                    </ng-select>
                </div>
            </div>

            <div class="form-group col-xl-6 col-md-6 col-sm-12">
                <label for="company">Teslim Şekli</label>
                <div class="form-group">
                    <ng-select [items]="deliveryMethods" bindLabel="deliveryMethodName" bindValue="id"
                        formControlName="deliveryMethodId"></ng-select>
                    <div *ngIf="deliveryForm.get('deliveryMethodId').hasError('required') && deliveryForm.get('deliveryMethodId').touched"
                        class="text-danger">
                        Firma seçimi zorunludur.
                    </div>
                </div>
            </div>

            <div class="form-group col-xl-6 col-md-6 col-sm-12">
                <label for="company">Getiren Kişi</label>
                <div class="form-group">
                    <input type="text" id="deliveryPerson" class="form-control" placeholder="Getiren Kişi"
                        maxlength="50" formControlName="deliveryPerson" />
                </div>
            </div>

            <div class="form-group col-xl-6 col-md-6 col-sm-12">
                <div class="form-group">
                    <label>Açıklama</label>
                    <div class="form-group">
                        <textarea class="form-control" id="basicTextarea" rows="1" placeholder="Açıklama."
                            formControlName="description"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()" rippleEffect>
        İptal
    </button>
    <button type="button" class="btn btn-success" rippleEffect (click)="onUpdateDelivery()" [disabled]="!deliveryForm.valid">
        Güncelle
    </button>
</div>